import React from 'react';
import { FaTimes, FaLock, FaExclamationTriangle } from 'react-icons/fa';

export const PaywallModal = ({ isOpen, onClose, feature, onUpgrade, limitInfo = null }) => {
  if (!isOpen) return null;

  const isLimitReached = limitInfo && !limitInfo.allowed;
  const headerColor = isLimitReached ? 'from-red-600 to-red-700' : 'from-purple-600 to-purple-700';
  const headerIcon = isLimitReached ? <FaExclamationTriangle /> : <FaLock />;
  const headerTitle = isLimitReached ? 'Daily Limit Reached' : 'Premium Feature';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        {/* Header */}
        <div className={`bg-gradient-to-r ${headerColor} px-6 py-4 flex items-center justify-between`}>
          <div className="flex items-center gap-2">
            {headerIcon && <span className="text-white text-xl">{headerIcon}</span>}
            <h2 className="text-xl font-bold text-white">{headerTitle}</h2>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:bg-opacity-80 rounded-full p-1 transition"
          >
            <FaTimes size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6">
          {isLimitReached ? (
            <>
              <p className="text-gray-700 mb-4">
                You've reached your daily limit of <strong>{limitInfo.limit} Ask YOGi requests</strong>.
              </p>
              <p className="text-gray-600 mb-4">
                Upgrade to Premium for unlimited AI-powered suggestions.
              </p>
              <div className="bg-red-50 p-4 rounded-lg mb-6 border border-red-200">
                <p className="text-sm text-red-700 font-semibold mb-2">Today's Usage:</p>
                <p className="text-sm text-red-600">{limitInfo.requestsToday} / {limitInfo.limit} requests used</p>
                <p className="text-xs text-red-500 mt-2">Limit resets at midnight</p>
              </div>
            </>
          ) : (
            <>
              <p className="text-gray-700 mb-4">
                <strong>{feature}</strong> is a premium feature. Upgrade to Premium to unlock unlimited access to AI-powered suggestions.
              </p>
            </>
          )}
          
          <div className="bg-purple-50 p-4 rounded-lg mb-6">
            <h3 className="font-semibold text-gray-800 mb-2">Premium includes:</h3>
            <ul className="text-sm text-gray-700 space-y-1">
              <li>✓ Unlimited Ask YOGi AI suggestions</li>
              <li>✓ Advanced export (PDF, Email, Share)</li>
              <li>✓ Collaborate with others</li>
              <li>✓ Save templates & cloning</li>
              <li>✓ Priority support</li>
            </ul>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-100 px-6 py-4 flex gap-3 justify-end border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 font-medium"
          >
            Maybe Later
          </button>
          <button
            onClick={onUpgrade}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-medium"
          >
            Upgrade Now
          </button>
        </div>
      </div>
    </div>
  );
};
